import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

import { ssoGroupsMappingText } from "../../../../assets/texts/Settings/sso";

type SsoGroupMappingHeadersProps = {
  showOrganizationColumn: boolean;
};

const SsoGroupMappingHeaders = ({ showOrganizationColumn }: SsoGroupMappingHeadersProps) => (
  <Stack
    direction="row"
    gap={1}
    sx={{ width: "100%", alignItems: "center", fontWeight: 500, textAlign: "left" }}
    data-cy="sso-group-mapping-headers"
  >
    <Box
      sx={{
        flex: 1,
        pl: 4,
        alignItems: "center",
        display: "flex",
        minHeight: 40,
        minWidth: showOrganizationColumn ? "calc(33%)" : "calc(50% - 24px)",
      }}
    >
      <Typography
        variant="subtitle2"
        color="text.primary"
        sx={{ alignItems: "center", display: "flex" }}
        data-cy="group-id-header"
      >
        {ssoGroupsMappingText.GROUP_ID_HEADER}
      </Typography>
      <Tooltip placement="right" arrow={true} title={ssoGroupsMappingText.GROUP_ID_TOOLTIP}>
        <IconButton size="small" sx={{ ml: 0.25 }}>
          <InfoOutlinedIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
    <Typography
      variant="subtitle2"
      color="text.primary"
      sx={{
        flex: 1,
        pl: showOrganizationColumn ? 0 : 2,
        pr: 6,
        alignItems: "center",
        display: "flex",
        minHeight: 40,
      }}
      data-cy="role-header"
    >
      {ssoGroupsMappingText.ROLE_ID_HEADER}
    </Typography>
    {showOrganizationColumn && (
      <Box sx={{ flex: 1, display: "flex", alignItems: "center", pr: 0, minHeight: 40 }}>
        <Typography
          variant="subtitle2"
          color="text.primary"
          sx={{ flex: 1, alignItems: "center", display: "flex", ml: -6 }}
          data-cy="organization-header"
        >
          {ssoGroupsMappingText.ORGANIZATION_ID_HEADER}
        </Typography>
      </Box>
    )}
  </Stack>
);

export default SsoGroupMappingHeaders;
